import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import { UserRouteName } from '@pages/users-page/users-page.module';
import { DvTabLink, DvTabsComponent } from '@devinco/ui/dds';

@Component({
  selector: 'app-users-tabs',
  templateUrl: './users-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DvTabsComponent, RouterOutlet],
})
export class UsersTabsComponent implements OnInit {
  private translate = inject(TranslateService);
  private router = inject(Router);
  private rolesService = inject(UserRolesAndPermissionsService);

  tabLinks: DvTabLink[];
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.toggleTabVisibility();
    this.toggleTabLinks();
    this.listenToUrlChanges();
  }

  private toggleTabVisibility(): void {
    this.tabLinks = [
      {
        label: this.translate.instant('User.Information'),
        link: UserRouteName.Information,
        id: UserRouteName.Information,
      },
    ];

    this.rolesService
      .getUserRolesAndPermissions()
      .pipe(take(1))
      .subscribe(rolesAndPerm => {
        if (rolesAndPerm.Permissions.includes(RolesAndPermissions.UserRead)) {
          this.tabLinks.push(
            {
              label: this.translate.instant('User.AccessControl'),
              link: UserRouteName.AccessControl,
              id: UserRouteName.AccessControl,
            },
            {
              label: this.translate.instant('User.Properties'),
              link: UserRouteName.Properties,
              id: UserRouteName.Properties,
            },
            {
              label: this.translate.instant('User.Devices'),
              link: UserRouteName.Devices,
              id: UserRouteName.Devices,
            }
          );
        }
      });
  }

  private listenToUrlChanges(): void {
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.toggleTabLinks();
        }
      });
  }
  private toggleTabLinks(): void {
    this.tabLinks = this.tabLinks.map(tabLink => ({
      ...tabLink,
      disable:
        this.router.url.includes('/new/information') &&
        tabLink.link !== 'information'
          ? true
          : false,
    }));
  }
}
